import { Box, Typography } from "@mui/material";

import BszSubjectChip from "./BszSubjectChip";

export default function BszSubjectCategory({
  category,
  subjects,
  grouped,
  selectedSubject,
  onSelectSubject,
}) {
  if (subjects.length === 0) return null;

  return (
    <Box>
      {/* ✅ CATEGORY LABEL */}
      <Typography
        variant="caption"
        sx={{
          opacity: 0.6,
          ml: 0.5,
        }}
      >
        {category}
      </Typography>

      {/* ✅ SUBJECT CHIPS */}
      <Box
        sx={{
          display: "flex",
          flexWrap: "wrap",
          gap: 1,
          mt: 0.5,
        }}
      >
        {subjects.map((subject) => (
          <BszSubjectChip
            key={subject}
            subject={subject}
            count={grouped[subject]?.length || 0}
            selected={selectedSubject === subject}
            onClick={() =>
              onSelectSubject(selectedSubject === subject ? null : subject)
            }
          />
        ))}
      </Box>
    </Box>
  );
}
